import { render, staticRenderFns } from "./ArticlePost.vue?vue&type=template&id=12d63e0e&scoped=true"
import script from "./ArticlePost.vue?vue&type=script&lang=js"
export * from "./ArticlePost.vue?vue&type=script&lang=js"
import style0 from "./ArticlePost.vue?vue&type=style&index=0&id=12d63e0e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d63e0e",
  null
  
)

export default component.exports